<div class="blade-wrapper">
    <div class="blade-header" *ngIf="!showInDialog || (showInDialog && hasToolbar)">
      <div           class="blade-tools">
      </div>
      <ng-content></ng-content>
    </div>

  <div class="blade-content">
    <div class="datex-hub">
      <ng-container
                    *ngIf="initialized ">
        <div class="hubdata">
          <h1 class="hubname" *ngIf="!showInDialog">{{hubTitle}}</h1>
          <h6 class="hubdesc">{{hubDescription}}</h6>
          <div class="hub-filters">
            <div class="fieldsetsGroup">
              <div [formGroup]="formGroup"
                   class="formdata">
                <div data-cy="fieldset-id-newGroup1"
                     *ngIf="!filtersets.newGroup1.hidden && !filtersets.newGroup1.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': filtersets.newGroup1.collapsible }">
                    <div *ngIf="!filtersets.newGroup1.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="filtersets.newGroup1.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{filtersets.newGroup1.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="filtersets.newGroup1.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !filtersets.newGroup1.expanded, 'icon-ic_fluent_chevron_up_20_filled': filtersets.newGroup1.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="filtersets.newGroup1.expanded"
                         class="fieldsetsGroup">
                            <div data-cy="field-id-owner" *ngIf="!filters.owner.hidden && !filters.owner.removed" 
                                  class="field-container standard {{filters.owner.invalid ? 'invalid' : ''}}"
                                  [ngStyle]="filters.owner.styles.style"
                                  [ngClass]="filters.owner.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.owner.label + (filters.owner.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.owner.label}}<span *ngIf="filters.owner.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <Owners-owners_dd_single 
                                  data-cy="selector"
                                  [type]="filters.owner.control.type"
                                  formControlName="owner"
                                  (displayTextChange)="filters.owner.control.displayText=$event"
                                  [placeholder]="filters.owner.control.placeholder"
                                  [styles]="filters.owner.control.styles"
                                  [tooltip]="filters.owner.control.tooltip"
                                [statusId]="$fields_owner_selector_inParams_statusId"
                                [projectId]="$fields_owner_selector_inParams_projectId"
                              >
                              </Owners-owners_dd_single>
                              <ng-container *ngIf="filters.owner.invalid">
                                <ng-container *ngFor="let error of filters.owner.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-project" *ngIf="!filters.project.hidden && !filters.project.removed" 
                                  class="field-container standard {{filters.project.invalid ? 'invalid' : ''}}"
                                  [ngStyle]="filters.project.styles.style"
                                  [ngClass]="filters.project.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.project.label + (filters.project.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.project.label}}<span *ngIf="filters.project.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <Owners-projects_dd_single 
                                  data-cy="selector"
                                  [type]="filters.project.control.type"
                                  formControlName="project"
                                  (displayTextChange)="filters.project.control.displayText=$event"
                                  [placeholder]="filters.project.control.placeholder"
                                  [styles]="filters.project.control.styles"
                                  [tooltip]="filters.project.control.tooltip"
                                [statusId]="$fields_project_selector_inParams_statusId"
                                [ownerId]="$fields_project_selector_inParams_ownerId"
                              >
                              </Owners-projects_dd_single>
                              <ng-container *ngIf="filters.project.invalid">
                                <ng-container *ngFor="let error of filters.project.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-warehouse" *ngIf="!filters.warehouse.hidden && !filters.warehouse.removed" 
                                  class="field-container standard {{filters.warehouse.invalid ? 'invalid' : ''}}"
                                  [ngStyle]="filters.warehouse.styles.style"
                                  [ngClass]="filters.warehouse.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.warehouse.label + (filters.warehouse.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.warehouse.label}}<span *ngIf="filters.warehouse.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <Locations-warehouses_dd_multi 
                                  data-cy="selector-multi"
                                  [type]="filters.warehouse.control.type"
                                  formControlName="warehouse"
                                  (displayTextChange)="filters.warehouse.control.displayText=$event"
                                  [placeholder]="filters.warehouse.control.placeholder"
                                  [styles]="filters.warehouse.control.styles"
                                  [tooltip]="filters.warehouse.control.tooltip"
                              >
                              </Locations-warehouses_dd_multi>
                              <ng-container *ngIf="filters.warehouse.invalid">
                                <ng-container *ngFor="let error of filters.warehouse.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-materials" *ngIf="!filters.materials.hidden && !filters.materials.removed" 
                                  class="field-container standard {{filters.materials.invalid ? 'invalid' : ''}}"
                                  [ngStyle]="filters.materials.styles.style"
                                  [ngClass]="filters.materials.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.materials.label + (filters.materials.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.materials.label}}<span *ngIf="filters.materials.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <Materials-materials_by_project_dd_multi 
                                  data-cy="selector-multi"
                                  [type]="filters.materials.control.type"
                                  formControlName="materials"
                                  (displayTextChange)="filters.materials.control.displayText=$event"
                                  [placeholder]="filters.materials.control.placeholder"
                                  [styles]="filters.materials.control.styles"
                                  [tooltip]="filters.materials.control.tooltip"
                                [projectId]="$fields_materials_selector_inParams_projectId"
                              >
                              </Materials-materials_by_project_dd_multi>
                              <ng-container *ngIf="filters.materials.invalid">
                                <ng-container *ngFor="let error of filters.materials.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-date_from" *ngIf="!filters.date_from.hidden && !filters.date_from.removed" 
                                  class="field-container standard {{filters.date_from.invalid ? 'invalid' : ''}}"
                                  [ngStyle]="filters.date_from.styles.style"
                                  [ngClass]="filters.date_from.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.date_from.label + (filters.date_from.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.date_from.label}}<span *ngIf="filters.date_from.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <app-datebox 
                                  data-cy="dateBox"
                                  formControlName="date_from"
                                  [format]="filters.date_from.control.format"
                                  [mode]="filters.date_from.control.mode"
                                  [ngStyle]="filters.date_from.control.styles.style"
                                  [ngClass]="filters.date_from.control.styles.classes"
                                  [tooltip]="filters.date_from.control.tooltip">
                              </app-datebox>
                              <ng-container *ngIf="filters.date_from.invalid">
                                <ng-container *ngFor="let error of filters.date_from.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-date_to" *ngIf="!filters.date_to.hidden && !filters.date_to.removed" 
                                  class="field-container standard {{filters.date_to.invalid ? 'invalid' : ''}}"
                                  [ngStyle]="filters.date_to.styles.style"
                                  [ngClass]="filters.date_to.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.date_to.label + (filters.date_to.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.date_to.label}}<span *ngIf="filters.date_to.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <app-datebox 
                                  data-cy="dateBox"
                                  formControlName="date_to"
                                  [format]="filters.date_to.control.format"
                                  [mode]="filters.date_to.control.mode"
                                  [ngStyle]="filters.date_to.control.styles.style"
                                  [ngClass]="filters.date_to.control.styles.classes"
                                  [tooltip]="filters.date_to.control.tooltip">
                              </app-datebox>
                              <ng-container *ngIf="filters.date_to.invalid">
                                <ng-container *ngFor="let error of filters.date_to.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>            </div>
                        </div>
                      </div>
                    </div>
            </div>
          </div>
        </div>


        <div class="datex-tabcontrol" *ngIf="!this.rootTabGroup.allTabsHidden">
          <div class="tab-container">
            <div *ngIf="tabs.shipping.hasTabToShow" class="tab" data-cy="tab-shipping">
              <h2 [className]="tabs.shipping.active? 'active': ''" (click)="tabs.shipping.activate()">{{tabs.shipping.title}}</h2>
            </div>
            <div *ngIf="tabs.receiving.hasTabToShow" class="tab" data-cy="tab-receiving">
              <h2 [className]="tabs.receiving.active? 'active': ''" (click)="tabs.receiving.activate()">{{tabs.receiving.title}}</h2>
            </div>
            <div *ngIf="tabs.inventory.hasTabToShow" class="tab" data-cy="tab-inventory">
              <h2 [className]="tabs.inventory.active? 'active': ''" (click)="tabs.inventory.activate()">{{tabs.inventory.title}}</h2>
            </div>
            <div *ngIf="tabs.operations.hasTabToShow" class="tab" data-cy="tab-operations">
              <h2 [className]="tabs.operations.active? 'active': ''" (click)="tabs.operations.activate()">{{tabs.operations.title}}</h2>
            </div>
            <div *ngIf="tabs.billing.hasTabToShow" class="tab" data-cy="tab-billing">
              <h2 [className]="tabs.billing.active? 'active': ''" (click)="tabs.billing.activate()">{{tabs.billing.title}}</h2>
            </div>
          </div>
        
              <FootPrintPortalManager-reports_list *ngIf="tabs.shipping.active"
              #$tabs_shipping
              [report_group]="$tabs_shipping_reports_list_inParams_report_group"
              [projectId]="$tabs_shipping_reports_list_inParams_projectId"
              [warehouseId]="$tabs_shipping_reports_list_inParams_warehouseId"
              [materialIds]="$tabs_shipping_reports_list_inParams_materialIds"
              [fromDate]="$tabs_shipping_reports_list_inParams_fromDate"
              [toDate]="$tabs_shipping_reports_list_inParams_toDate"
              [ownerId]="$tabs_shipping_reports_list_inParams_ownerId"
              ($refreshEvent)="refresh(false, false, '$tabs_shipping')">
              </FootPrintPortalManager-reports_list>
              <FootPrintPortalManager-reports_list *ngIf="tabs.receiving.active"
              #$tabs_receiving
              [report_group]="$tabs_receiving_reports_list_inParams_report_group"
              [projectId]="$tabs_receiving_reports_list_inParams_projectId"
              [warehouseId]="$tabs_receiving_reports_list_inParams_warehouseId"
              [materialIds]="$tabs_receiving_reports_list_inParams_materialIds"
              [fromDate]="$tabs_receiving_reports_list_inParams_fromDate"
              [toDate]="$tabs_receiving_reports_list_inParams_toDate"
              [ownerId]="$tabs_receiving_reports_list_inParams_ownerId"
              ($refreshEvent)="refresh(false, false, '$tabs_receiving')">
              </FootPrintPortalManager-reports_list>
              <FootPrintPortalManager-reports_list *ngIf="tabs.inventory.active"
              #$tabs_inventory
              [report_group]="$tabs_inventory_reports_list_inParams_report_group"
              [projectId]="$tabs_inventory_reports_list_inParams_projectId"
              [warehouseId]="$tabs_inventory_reports_list_inParams_warehouseId"
              [materialIds]="$tabs_inventory_reports_list_inParams_materialIds"
              [fromDate]="$tabs_inventory_reports_list_inParams_fromDate"
              [toDate]="$tabs_inventory_reports_list_inParams_toDate"
              [ownerId]="$tabs_inventory_reports_list_inParams_ownerId"
              ($refreshEvent)="refresh(false, false, '$tabs_inventory')">
              </FootPrintPortalManager-reports_list>
              <FootPrintPortalManager-reports_list *ngIf="tabs.operations.active"
              #$tabs_operations
              [report_group]="$tabs_operations_reports_list_inParams_report_group"
              [projectId]="$tabs_operations_reports_list_inParams_projectId"
              [warehouseId]="$tabs_operations_reports_list_inParams_warehouseId"
              [materialIds]="$tabs_operations_reports_list_inParams_materialIds"
              [fromDate]="$tabs_operations_reports_list_inParams_fromDate"
              [toDate]="$tabs_operations_reports_list_inParams_toDate"
              [ownerId]="$tabs_operations_reports_list_inParams_ownerId"
              ($refreshEvent)="refresh(false, false, '$tabs_operations')">
              </FootPrintPortalManager-reports_list>
              <FootPrintPortalManager-reports_list *ngIf="tabs.billing.active"
              #$tabs_billing
              [report_group]="$tabs_billing_reports_list_inParams_report_group"
              [projectId]="$tabs_billing_reports_list_inParams_projectId"
              [warehouseId]="$tabs_billing_reports_list_inParams_warehouseId"
              [materialIds]="$tabs_billing_reports_list_inParams_materialIds"
              [fromDate]="$tabs_billing_reports_list_inParams_fromDate"
              [toDate]="$tabs_billing_reports_list_inParams_toDate"
              [ownerId]="$tabs_billing_reports_list_inParams_ownerId"
              ($refreshEvent)="refresh(false, false, '$tabs_billing')">
              </FootPrintPortalManager-reports_list>
        </div>

      </ng-container>
    </div>
  </div>
</div>